import makeList from './makeList.js'

let viewFloor = '衛星受信棟'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '衛星受信棟(1)',
        file: './data/I15a.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 809.7062579821201, 366.53895274584926 ],
          syowaZoom: [ 594.6547884187082, 374.16481069042317 ],
        },
      },
      { description: '衛星受信棟(2)',
        file: './data/I15c.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 809.7062579821201, 366.53895274584926 ],
          syowaZoom: [ 463.25167037861917, 436.52561247216033 ],
        },
      },
      { description: '衛星受信棟(3)',
        file: './data/I15d.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 809.7062579821201, 366.53895274584926 ],
          syowaZoom: [ 291.7594654788419, 554.56570155902 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
